import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Discounts({ children }) {
  useInjectSaga({ key: 'reportsDiscounts', saga });
  useInjectReducer({ key: 'reportsDiscounts', reducer });

  return React.Children.only(children);
}

Discounts.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withReportsDiscounts } from './withReportsDiscounts';
export default compose(withConnect, memo)(Discounts);
